export const SET_EMAIL = 'SET_EMAIL'
export const AUTHENTICATE = 'AUTHENTICATE'
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS'
export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED'
export const RESET_ERROR = 'RESET_ERROR'


export const GET_ALL_APPLICATIONS = 'GET_ALL_APPLICATIONS'
export const GET_ALL_APPLICATIONS_FULFILLED = 'GET_ALL_APPLICATIONS_FULFILLED'
export const GET_ALL_APPLICATIONS_REJECTED = 'GET_ALL_APPLICATIONS_REJECTED'

export const GET_USER_ASSIGNED_APPLICATIONS = 'GET_USER_ASSIGNED_APPLICATIONS'
export const GET_USER_ASSIGNED_APPLICATIONS_FULFILLED = 'GET_USER_ASSIGNED_APPLICATIONS_FULFILLED'
export const GET_USER_ASSIGNED_APPLICATIONS_REJECTED = 'GET_USER_ASSIGNED_APPLICATIONS_REJECTED'

export const GET_COMPLETE_USER_DETAILS = 'GET_COMPLETE_USER_DETAILS'
export const GET_COMPLETE_USER_DETAILS_REJECTED = 'GET_COMPLETE_USER_DETAILS_REJECTED'
export const GET_COMPLETE_USER_DETAILS_FULFILLED = 'GET_COMPLETE_USER_DETAILS_FULFILLED'

export const SET_DIRECTORY = 'SET_DIRECTORY'

export const GET_ALL_DIRECTORIES = 'GET_ALL_DIRECTORIES'
export const GET_ALL_DIRECTORIES_FULFILLED = 'GET_ALL_DIRECTORIES_FULFILLED'
export const GET_ALL_DIRECTORIES_REJECTED = 'GET_ALL_DIRECTORIES_REJECTED'